/**
 * Created by fworld on 2019/9/19.
 */
export default {
    name: 'factory.device',
    path: 'device',
    meta: {title: '经销商管理'},
    component: () => import('@/pages/redirect'),
    redirect: {name: 'factory.device.list'},
    children: [
        {
            name: 'factory.device.list',
            path: 'list',
            meta: {title: '设备列表'},
            component: () => import('@/pages/Factory/Device/list'),
        },
    ]
}
